"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableLanguagesMapping = exports.convertForBackend = void 0;
/**
 * Convert a locale from UI format to backend format
 * i18next expects languages in the format below (`<lng>-<region>`) while the c1 backend expects in the format `<lng>_<region>`
 * TODO: convert on backend
 */
var convertForBackend = function (locale) {
    var lang = locale.substring(0, 2);
    var region = locale.substring(3, 5);
    return lang + (region ? '_' + region.toUpperCase() : '');
};
exports.convertForBackend = convertForBackend;
exports.availableLanguagesMapping = [
    { name: 'English', id: 'en' },
    { name: 'English (UK & AUS)', id: 'en-gb' },
    { name: 'Français (France)', id: 'fr' },
    { name: 'Svenska', id: 'sv' },
    { name: 'Suomi', id: 'fi' },
    { name: 'Norwegian (Bokmal)', id: 'nb' },
    { name: 'Dansk', id: 'da' },
    { name: 'Français (Canada)', id: 'fr-ca' },
    { name: 'Español', id: 'es' },
    { name: '日本語', id: 'ja-jp', translated: true },
    { name: 'Português (Portugal)', id: 'pt' },
    { name: 'Português (Brasil)', id: 'pt-br' },
    { name: 'Deutsch (Deutschland)', id: 'de' },
    { name: 'Nederlands (Nederland)', id: 'nl' },
    { name: 'Polski (Polska)', id: 'pl' },
    { name: 'Italiano (Italia)', id: 'it' },
    { name: '简体中文', id: 'zh-cn' },
    { name: '繁體中文', id: 'zh-tw' },
    { name: '한국어', id: 'ko-kr' },
];
//# sourceMappingURL=index.js.map